import { getVerboseHistoryFormattedTimestamp, getHistoryFormattedTimestamp
// @ts-expect-error module not typed
} from 'conversations-message-history/util/getHistoryFormattedTimestamp';
import PropTypes from 'prop-types';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageHeaderTimestamp = ({
  timestamp
}) => {
  const hourMinTimestamp = getHistoryFormattedTimestamp(timestamp);
  if (!hourMinTimestamp) return null;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: getVerboseHistoryFormattedTimestamp(timestamp),
    children: /*#__PURE__*/_jsx(Flex, {
      as: "span",
      flexDirection: "row",
      alignItems: "center",
      marginInlineStart: "auto",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        "data-test-vr-hidden": true,
        "data-test-id": "sender-header-content-timestamp",
        children: hourMinTimestamp
      })
    })
  });
};
MessageHeaderTimestamp.displayName = 'MessageHeaderTimestamp';
MessageHeaderTimestamp.propTypes = {
  // @ts-expect-error this is correct, typescript is displeased by it.  propTypes will be removed once all CommonMessage consumers are ts
  timestamp: PropTypes.number
};
export default MessageHeaderTimestamp;